module.exports = require("./ru-UA");